import PropTypes from 'prop-types'

import { datePropType, idPropType, regexPropType } from '~/src/Lib/PropTypes'
import { shape as noteShape } from '~/src/Note/bundle'

export const schemas = [
  'notes',
  'notifications',
  'readings',
  'targetRanges',
  'tasks',
  'harvests',
  'lightSchedules',
]

export const annotationShape = PropTypes.oneOfType([
  // one shape per annotation type
  noteShape,
  // notification
  PropTypes.shape({
    subject: PropTypes.string,
    message: PropTypes.string,
  }),
  // manual reading
  PropTypes.shape({
    dataType: PropTypes.number,
    value: PropTypes.number,
  }),
])

export const annotationsShape = PropTypes.objectOf(annotationShape)

export const annotationItemShape = PropTypes.shape({
  id: idPropType,
  uuid: regexPropType(/[a-z]+_\d+/).isRequired,
  timestamp: datePropType,
  schema: PropTypes.string,
  annotation: annotationShape,
})

export const annotationItemsShape = PropTypes.arrayOf(annotationItemShape)
